import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=db9a2564&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db9a2564')) {
      api.createRecord('db9a2564', component.options)
    } else {
      api.reload('db9a2564', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=db9a2564&", function () {
      api.rerender('db9a2564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2twYD7uYoT5DR/JS/comp/childrenage.vue"
export default component.exports